//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export class BaseEntity {
    identifier : string;
    createdOn : string ;
    modifiedOn : string ;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.modifiedOn = null;
        }
}

export class CrawledUrl extends BaseEntity {
    userId : string;
    customerWebId : string;
    url : string;
    errors : string[];

    constructor() 
    {
    	        super();
		            this.userId = "" ;
                this.customerWebId = "" ;
                this.url = "" ;
                this.errors = [];
        }
}

export class CrawlUrlRequestVm {
    url : string;
    userId : string;
    webUserId : string;

    constructor() 
    {
    	            this.url = "" ;
                this.userId = "" ;
                this.webUserId = "" ;
        }
}

export class CrawlerConfig extends BaseEntity {
    caratteristicheConfig : SectionReadConfig[];
    altreCaratteristiche : SectionReadConfig[];
    dettaglioDeiCostiConfig : SectionReadConfig[];
    energyConfig : SectionReadConfig[];

    constructor() 
    {
    	        super();
		            this.caratteristicheConfig = [];
                this.altreCaratteristiche = [];
                this.dettaglioDeiCostiConfig = [];
                this.energyConfig = [];
        }
}

export class SectionReadConfig {
    sectionName : string;
    dataType : string;
    onOfficePropertyName : string;
    gerItas : GerIta[];

    constructor() 
    {
    	            this.sectionName = "" ;
                this.dataType = "" ;
                this.onOfficePropertyName = "" ;
                this.gerItas = [];
        }
}

export class GerIta {
    ita : string;
    ger : string;

    constructor() 
    {
    	            this.ita = "" ;
                this.ger = "" ;
        }
}

export class CrawlRequestQueue extends BaseEntity {
    userId : string;
    customerWebId : string;
    url : string;
    errors : string[];
    consumedOn : string ;
    finishedOn : string ;

    constructor() 
    {
    	        super();
		            this.userId = "" ;
                this.customerWebId = "" ;
                this.url = "" ;
                this.errors = [];
                this.consumedOn = null;
                this.finishedOn = null;
        }
}

export class KeyValuePairOfStringAndString {
    key : string;
    value : string;

    constructor() 
    {
    	            this.key = "" ;
                this.value = "" ;
        }
}

export class LocalizedValue {
    values : { [key: string]: string; };

    constructor() 
    {
    	            this.values = {};
        }
}

export class LocalizedEntity extends LocalizedValue {
    key : string;
    identifier : string;

    constructor() 
    {
    	        super();
		            this.key = "" ;
                this.identifier = "" ;
        }
}

export class LoginResponse {
    userId : string;
    webUserId : string;
    token : string;

    constructor() 
    {
    	            this.userId = "" ;
                this.webUserId = "" ;
                this.token = "" ;
        }
}

export class GetFieldsResponse {
    type : string;
    length : number;
    permittedvalues : { [key: string]: string; };
    default : string;
    filters : any[];
    dependencies : any[];
    compoundFields : any[];
    label : string;

    constructor() 
    {
    	            this.type = "" ;
                this.length = null ;
                this.permittedvalues = {};
                this.default = "" ;
                this.filters = [];
                this.dependencies = [];
                this.compoundFields = [];
                this.label = "" ;
        }
}

export class GetFieldsResponseForList extends GetFieldsResponse {
    fieldName : string;

    constructor() 
    {
    	        super();
		            this.fieldName = "" ;
        }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}